export enum EventClass {
  GUI = "GUI", //controls related events (option windows and such)
  GAMEPLAY = "GAMEPLAY", //gameplay related events like SPIN, SLAM_STOP, etc
  IGM_INTERFACE = "IGM_INTERFACE", //ingame interface related events
  SOUND = "SOUND", //sound events like PLAY and sound ID
  SYSTEM = "SYSTEM", //system events like window resize, etc
  INPUT = "INPUT", //input events like keys and mouse
}

export const EventType = {
  GUI: {
    CLICK: "CLICK",
    VALUE_CHANGED: "VALUE_CHANGED",
    SHOW_POPUP: "SHOW_POPUP",
    CLEAR_POPUP: "CLEAR_POPUP",
    SHOW_SETTINGS: "SHOW_SETTINGS",
    CLOSE_SETTINGS: "CLOSE_SETTINGS",
    SHOW_FAILED_BETS: "SHOW_FAILED_BETS",
  },
  IGM_INTERFACE: {
    SPIN: "SPIN",
    STOP: "STOP",
    COLLECT: "COLLECT",
    START_GAMBLE: "START_GAMBLE",
    START_LADDER: "START_LADDER",
    BUY_BONUS: "BUY_BONUS",
  },
  GAMEPLAY: {
    INITIALIZED: "INITIALIZED", //payload: {balance, bet} - sent after the RGS init step, before we are ready to play
    ROUND_START: "ROUND_START",
    ROUND_END: "ROUND_END", //payload: {isFeature, totalWinCash, balance ,bet}
    WIN_UPDATE: "WIN_UPDATE", //??ANDREI - notifies win line updates? payload format??
    REEL_MODIFIER_START: "REEL_MODIFIER_START", //payload: {strModifierType si bBlocking}
    REEL_MODIFIER_INIT: "REEL_MODIFIER_INIT", //payload: {strModifierType si bBlocking}
    WINLINE_PREVIEW: "WINLANE_PREVIEW",
    WINLINE_START: "WINLANE_START",
    WINLINE_END: "WINLANE_END",
    SET_PAUSE_INPUT: "SET_PAUSE_INPUT", //payload: {bPause}
    FEATURE_START: "FEATURE_START",
    FEATURE_END: "FEATURE_END",
    BATTERY_SAVER: "BATTERY_SAVER",
    GAMBLE_WIN: "GAMBLE_WIN",
    BOTTLE_WIN: "BOTTLE_WIN",
    PRIZE_CHANGE: "PRIZE_CHANGE",
  },
  SOUND: {
    PLAY: "PLAY", //payload: {soundID:ID, bLooping:true}
    STOP: "STOP", //payload: {soundID:ID}
  },
  SYSTEM: {
    CANVAS_RESIZED: "CANVAS_RESIZED", //payload: {canvasW, canvasH, bLandscape}
    LOADER_PROGRESS: "LOADER_PROGRESS", //payload: {fLoadPercent}
    APP_CHANGED_STATE: "APP_CHANGED_STATE", //payload: {strState}
    LANGUAGE_CHANGED: "LANGUAGE_CHANGED", //payload: {strLanguage}
    FOCUS_CHANGED: "FOCUS_CHANGED", //payload: {bFocused}
    COMM_REQUEST_SENT: "COMM_REQUEST_SENT", // received when we send server request
    COMM_ANSWER_RECEIVED: "COMM_ANSWER_RECEIVED", // received when the remote server answers
    APP_CHAMGE_SCREEN: "APP_CHANGE_SCREEN",
    ONLINE: "ONLINE",
    OFFLINE: "OFFLINE",
  },
  INPUT: {
    KEY_PRESSED: "KEY_PRESSED", //payload: {keyCode}
    KEY_RELEASED: "KEY_RELEASED", //payload {keyCode}
    SCROLL: "SCROLL", //payload {nDelta:can be pos or neg}
    KEY_UP: "KEY_UP",
    KEY_DOWN: "KEY_DOWN",
    CLICK: "CLICK",
    MOUSE_WHEEL: "MOUSE_WHEEL",
    //MOUSE_CLICK...etc
  },
  SCREENS: {
    LOADING: "LOADING",
    ONBOARDING: "ONBOARDING",
    GAME: "GAME",
  },
};
